import { ReactNode } from "react";

type ConditionalWrapperProps = {
	/** Boolean condition to determine which wrapper to use (true -> wrapper / false -> fallbackWrapper) */
	condition: boolean;
	/** Use whenTrue function when condition is true */
	whenTrue: (children: ReactNode) => ReactNode;
	/** Use whenFalse function when condition is false */
	whenFalse?: (children: ReactNode) => ReactNode;
	/** Content to be wrapped */
	children: ReactNode;
};

export const ConditionalWrapper = ({ condition, whenTrue, whenFalse, children }: ConditionalWrapperProps) => {
	if (condition) return whenTrue(children);

	if (whenFalse) return whenFalse(children);

	return children;
};
